export enum RideTab {
    UPCOMING = 0,
    WISHLIST = 1,
    HISTORY = 2,
}
